export const BOOKABLE = '[Bookable]'

export const CREATE_BOOKABLE = `${BOOKABLE} CREATE_BOOKABLE`
export const UPDATE_BOOKABLE = `${BOOKABLE} UPDATE_BOOKABLE`
export const GET_BOOKABLES = `${BOOKABLE} GET_BOOKABLES`
export const SET_BOOKABLES = `${BOOKABLE} SET_BOOKABLES`
